import React, { useState } from 'react';
import { connect } from 'react-redux';
import FiltroToku from './list-transactions-toku/components/FiltroToku';
import { listTokuAction } from '_models/redux/list-transactions-toku/action';
import Grid from '@mui/material/Grid';
import { Typography, Box } from '@mui/material';
import { PageTokuHook } from './list-transactions-toku/hooks/PageTokuHook';
import { CircularProgressStyle } from './list-transactions-toku/style/style';
import DataTable from 'widgets/datagrid/DataTable';
import { detailTransactionTokuAction } from '_models/redux/detail-transactions-toku/action';
import { cleanTransactionsTokuClean } from '_models/redux/list-transactions-toku/clean-action';
import { cleanDetailTokuAction } from '_models/redux/detail-transactions-toku/clean-action';
import { actionReportTransactionsFraud } from '_models/redux/report-transaction-fraud/action';
import { cleanReportTransactionsFraud } from '_models/redux/report-transaction-fraud/clean_action';
import { cleanReportPrepaidChargebackDetails } from '_models/redux/report-transaction-chargeback/clean_action';
import { actionReportTransactionsChargeback } from '_models/redux/report-transaction-chargeback/action';
import TokuMessageDialog from './components/TokuMessageDialog';
import TokuFraudDialog from './components/TokuFraudDialog';
import TokuDetailsDialog from './components/TokuDetailsDialog';

const PageToku = ({
  listTokuAction,
  cleanTransactionsTokuClean,
  listTransactionsToku,
  detailTransactionTokuAction,
  cleanDetailTokuAction,
  detailsTransactionsToku,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  reportTransactionsFraud,
  reportTransactionsChargeback,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    isDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    getBackgroundColor,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    error,
    handleConfirm,
    loadingFraudAndChargeback,
    isError,
    handleCloseFraudChargeback,
    setOpenActionFraud,
    handleOpenPopUp,
    loadingDetail,
  } = PageTokuHook({
    listTokuAction,
    cleanTransactionsTokuClean,
    listTransactionsToku,
    detailTransactionTokuAction,
    cleanDetailTokuAction,
    detailsTransactionsToku,
    actionReportTransactionsFraud,
    cleanReportTransactionsFraud,
    reportTransactionsFraud,
    reportTransactionsChargeback,
    cleanReportPrepaidChargebackDetails,
    actionReportTransactionsChargeback,
    transactionId,
    onClose,
  });

  const [hasSearched, setHasSearched] = useState(false);
  const onSubmitWithFlag = (...args) => {
    setHasSearched(true);
    return onSubmit(...args);
  };
  return (
    <>
      <Grid>
        <h4> Transacciones de Toku </h4>
      </Grid>
      <Grid marginBottom={4}>
        <FiltroToku
          onSubmit={onSubmitWithFlag}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Grid>
      <Grid>
        {mappedRows?.length > 0 ? (
          <Grid paddingRight={5} paddingLeft={0}>
            <Box>
              <DataTable
                rows={mappedRows}
                columns={Columns}
                onRowClick={handleRowClick}
                page={page}
                pageSize={size}
                rowCount={pagination?.total_rows ?? 0}
                onPageChange={pagination?.handleChangePage}
                handleChangePageSize={pagination?.handleChangePageSize}
                getBackgroundColor={getBackgroundColor}
                mappedRows={mappedRows}
                loading={loading}
              />
            </Box>
          </Grid>
        ) : (
          hasSearched && <Typography variant='h6'>No hay registros disponibles</Typography>
        )}
      </Grid>

      <TokuDetailsDialog
        open={isDialogOpenDetails}
        onClose={handleClose}
        detailsTransactionsToku={detailsTransactionsToku}
        handleOpenPopUp={handleOpenPopUp}
        setOpenActionFraud={setOpenActionFraud}
        loadingDetail={loadingDetail}
        CircularProgressStyle={CircularProgressStyle}
      />

      <TokuMessageDialog open={isDialogOpen} onClose={handleClose} dialogMessage={dialogMessage} />

      <TokuFraudDialog
        open={openActionFraud}
        onClose={handleCloseFraudChargeback}
        setDescriptionTransaction={setDescriptionTransaction}
        setError={setError}
        error={error}
        loadingFraudAndChargeback={loadingFraudAndChargeback}
        dialogMessage={dialogMessage}
        isError={isError}
        reportTransactionsFraud={reportTransactionsFraud}
        reportTransactionsChargeback={reportTransactionsChargeback}
        handleConfirm={handleConfirm}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  listTransactionsToku: state?.listTransactionsToku,
  detailsTransactionsToku: state?.detailsTransactionsToku,
  reportTransactionsFraud: state?.reportTransactionsFraud,
  reportTransactionsChargeback: state?.reportTransactionsChargeback,
});

const mapDispatchToProps = {
  listTokuAction,
  cleanTransactionsTokuClean,
  detailTransactionTokuAction,
  cleanDetailTokuAction,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageToku);
